module.exports = __webpack_public_path__ + "static/img/wechatcode1.e6ba25d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appdownicon/wechatcode1.jpg
// module id = B6X+
// module chunks = 129